// extracted by mini-css-extract-plugin
export default {"card_wrapper":"LatestNews_card_wrapper__zq8ve","card":"LatestNews_card__JwJGl"};